// src/components/ContactForm.tsx
import React, { useState } from "react";

type Props = {
  imageSrc?: string;
  imageAlt?: string;
  accentHex?: string; // color para el texto resaltado y el botón
  onSubmit?: (data: { name: string; phone: string; email: string }) => void;
};

const ContactForm: React.FC<Props> = ({
  imageSrc = "/images/contact-bg.png",
  imageAlt = "Asesor en calle colonial",
  accentHex = "#E88809",
  onSubmit,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data = {
      name: String(formData.get("name") || ""),
      phone: String(formData.get("phone") || ""),
      email: String(formData.get("email") || ""),
    };
    setLoading(true);
    try {
      onSubmit?.(data);
      if (!onSubmit) console.log("Form data:", data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section aria-label="Formulario de contacto para inversión" className="w-full bg-white">
      <div className="w-full grid grid-cols-1 lg:grid-cols-[50%_50%]">
        {/* Columna izquierda: imagen */}
        <div className="relative h-64 sm:h-80 md:h-[36rem] lg:h-[45rem]">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
        </div>

        {/* Columna derecha: copy + formulario */}
        <div className="px-8 sm:px-12 py-10 sm:py-14 flex items-center justify-start">
          <div className="w-full max-w-lg">
            <h2 className="font-extrabold leading-tight text-neutral-900" style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}>
              Completa el formulario y
              <span style={{ color: accentHex }}> empieza hoy tu camino</span>
              <span style={{ color: accentHex }}> de inversión</span>
            </h2>

            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
              {/* Nombre */}
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-semibold text-neutral-900"
                >
                  Nombre
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  placeholder="Nombre completo"
                  className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2.5 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900/10"
                />
              </div>

              {/* Teléfono */}
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-semibold text-neutral-900"
                >
                  Teléfono (WhatsApp)
                </label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  required
                  placeholder="Número de teléfono"
                  className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2.5 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900/10"
                />
              </div>

              {/* Correo */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-semibold text-neutral-900"
                >
                  Correo electrónico
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="Correo electrónico"
                  className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2.5 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900/10"
                />
              </div>

              {/* CTA */}
              <div className="pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="ml-auto flex items-center justify-center rounded-md px-5 py-2.5 font-semibold text-black disabled:opacity-60"
                  style={{ backgroundColor: accentHex }}
                >
                  {loading ? "Enviando…" : "Agendar la cita"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;